<script context="module">
    import { authenticated, Logout, ReleaseMode, CurrentWindow} from "./APIService";


    function logout(){
        Logout();
    }


    let isOpen = false;

function openNav() {
  document.getElementById("mySidebar").style.width = "250px";
  isOpen = true;
}

/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
function closeNav() {
  document.getElementById("mySidebar").style.width = "0";
  isOpen = false;
}

function Toggle(){
    if (isOpen) {
        closeNav();
    }
    else{
        openNav();
    }
}

function LoadHome(){
    CurrentWindow.set("HomeWindow");
}

function LoadGiftCodeWindow(){
  CurrentWindow.set("GiftCode");
}

function LoadUserWindow(){
  CurrentWindow.set("SearchUserWindow");
}

function LoadClanWindow(){
  CurrentWindow.set("ClanWindow");
}

</script>


<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <a class="navbar-brand" href="javascript:void(0)" on:click={Toggle}>
        &#9776;
        <img src="Images/logo.png" width="30" height="30" class="d-inline-block align-top" alt="">
        </a>
    <a class="navbar-brand" href="javascript:void(0)" on:click={LoadHome}>Support</a>
    <div >
      <ul class="navbar-nav">
        <li class="nav-item">
            <a class="nav-link" href="#">Welcome, {$authenticated.user}</a>
          </li>
        <li class="nav-item">
          <a class="nav-link" href="#" style="color: red;">{ReleaseMode} Server</a>
        </li>
        <li class="nav-item" id="logout" on:click={logout}>
          <a class="nav-link" href="#">Logout</a>
        </li>
      </ul>
    </div>
</nav>


<div id="mySidebar" class="sidebar">
    <a href="javascript:void(0)" class="closebtn" on:click={closeNav}>&laquo;</a>
    <a href="#" on:click={LoadHome}>Home</a>
    <a href="#" on:click={LoadUserWindow}>Find User</a>
    <a href="#" on:click={LoadGiftCodeWindow}>GiftCode</a>
    <a href="#" on:click={LoadClanWindow}>Find Clan</a>
<!--    <a href="#" on:click={downloadViolations}>Violations</a>-->
<!--    <a href="#" on:click={removeViolations}>RemoveViolations</a>-->
    <a href="#" on:click={logout}>Logout</a>
  </div>



<style>
    nav {
        padding-left: 1%;
        background-color: chocolate;
    }

    #logout{
        position: absolute;
        right: 10px;
        text-align: center;
        /* top: 0; */
        height: inherit;
    }


           /* The sidebar menu */
.sidebar {
  height: 100%; /* 100% Full-height */
  width: 0px; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1; /* Stay on top */
  top: 6%;
  left: 0;
  background-color: #111; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidebar */
}

/* The sidebar links */
.sidebar a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

/* When you mouse over the navigation links, change their color */
.sidebar a:hover {
  color: #f1f1f1;
}

/* Position and style the close button (top right corner) */
.sidebar .closebtn {
  position: absolute;
  top: 0;
  left: 0px;
  font-size: 36px;
  margin-left: 0px;
}

/* The button used to open the sidebar */
.openbtn {
  font-size: 20px;
  cursor: pointer;
  background-color: #111;
  color: white;
  padding: 10px 15px;
  border: none;
}

.openbtn:hover {
  background-color: #444;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left .5s; /* If you want a transition effect */
  padding: 20px;
  top: 6%;
  left: 0px; 
  padding-left: 0px;
  position: fixed;
  z-index: 10;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidebar {padding-top: 15px;}
  .sidebar a {font-size: 18px;}
} 
</style>